// src/config.js

// This is your new central configuration file.
// Update your email and Google Sheet URL here.

const config = {
    // IMPORTANT: Replace with the email address you want to receive order notifications.
    formSubmitEmail: "care.desimeal@gmail.com",

    // IMPORTANT: Replace with your actual Google Apps Script Web App URL.
    googleSheetUrl: "https://script.google.com/macros/s/AKfycbxiga6FTf7y6vSUjUB5WBLTrjKgtrfjhOl3O1e_WZSuUZUFfjynS4_3R5p1dH8dbw8/exec",

    callNumber: "9167551616",

    // IMPORTANT: Replace with your 10-digit WhatsApp number (no country code).
    whatsappNumber: "9167551616"
};

export default config